import { Injectable } from "@angular/core";

@Injectable()
export class SharedService {
    
    maskLastNames(names: string): string {
        const namesList = names.split(' ');
    
        if (namesList.length > 1) {
            const maskedNames = namesList
                .slice(0, -1)
                .map(name => name.substring(0, 2) + '*'.repeat(Math.max(name.length - 2, 0)))
                .join(' ') + ' ' + namesList[namesList.length - 1].substring(0, 2) + '*'.repeat(Math.max(namesList[namesList.length - 1].length - 2, 0));
    
            return maskedNames;
        } else {
            const name = namesList[0] || '';
            return name.substring(0, 2) + '*'.repeat(Math.max(name.length - 2, 0));
        }
    }
    getNewCustomerInfo(data: any): any {
        let newData: any = [];
        let apellido_maternoFind = data.find((x: any) => x.key == "apellido_materno");
        if(apellido_maternoFind)
        {
            apellido_maternoFind.value = apellido_maternoFind.value ? this.maskLastNames(apellido_maternoFind.value) : '';
        }
        let nombreFind = data.find((x: any) => x.key == "nombre");
        if(nombreFind)
        {
            nombreFind.value = nombreFind.value ? this.maskLastNames(nombreFind.value) : '';
        }
        data.forEach((element: any) => {
            if (element.key == "apellido_materno") {
                element.value = apellido_maternoFind.value;
            }
            if (element.key == "nombre") {
                element.value = nombreFind.value;
            }
            newData.push(element);
        });
        return newData;
    }
    getNameComplete(data: any): string {
        let name = "";
        let apellido_paternoFind = data.find((x: any) => x.key == "apellido_paterno");
        let nombre = data.find((x: any) => x.key == "nombre");
        let apellido_maternoFind = data.find((x: any) => x.key == "apellido_materno");
        name = nombre.value+" "+ (apellido_paternoFind.value ? apellido_paternoFind.value : '')+" "+ (apellido_maternoFind.value ? apellido_maternoFind.value : '');
        return name;
    }
}
